export default function stockPriceStepper(price) {
  let step = 1;
  if (price >= 200 && price < 500) {
    step = 2;
  } else if (price >= 500 && price < 2000) {
    step = 5;
  } else if (price >= 2000 && price < 5000) {
    step = 10;
  } else if (price >= 5000) {
    step = 25;
  }
  const sisa = price % step;

  return sisa === 0 ? step : step - sisa;
}
